import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Small delay to avoid flash on page load
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      accepted: true,
      timestamp: new Date().toISOString(),
      preferences: { essential: true, analytics: true }
    }));
    setShowBanner(false);
    window.dispatchEvent(new Event('cookie_consent_updated'));
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      accepted: false,
      timestamp: new Date().toISOString(),
      preferences: { essential: true, analytics: false }
    }));
    setShowBanner(false);
    window.dispatchEvent(new Event('cookie_consent_updated'));
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-slide-up">
      <div className="max-w-4xl mx-auto bg-slate-800 border border-slate-600 rounded-xl shadow-2xl p-4 md:p-6">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          {/* Icon and Text */}
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-2xl">🍪</span>
              <h3 className="text-lg font-semibold text-white">Cookie Notice</h3>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              We use essential cookies to keep our service running securely. We also use optional analytics cookies to improve your experience. Your health data is stored only on your device and never in cookies.
              {' '}
              <Link to="/privacy" className="text-blue-400 hover:text-blue-300 underline">
                Learn more about our privacy policy
              </Link>
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-sm font-medium text-slate-300 bg-slate-700 hover:bg-slate-600 rounded-lg transition order-2 sm:order-1"
            >
              Essential Only
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition order-1 sm:order-2"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>

      {/* Animation styles */}
      <style jsx>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}
